import { Injectable } from '@angular/core';
import { CalsoftDrawerComponent } from './drawer.component';

@Injectable({
    providedIn: 'root'
})
export class CalsoftDrawerService
{
    // Private
    private _componentRegistry: Map<string, CalsoftDrawerComponent>;

    /**
     * Constructor
     */
    constructor()
    {
        // Set the defaults
        this._componentRegistry = new Map<string, CalsoftDrawerComponent>();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register drawer component
     *
     * @param name
     * @param component
     */
    registerComponent(name: string, component: CalsoftDrawerComponent): void
    {
        this._componentRegistry.set(name, component);
    }

    /**
     * Deregister drawer component
     *
     * @param name
     */
    deregisterComponent(name: string): void
    {
        this._componentRegistry.delete(name);
    }

    /**
     * Get drawer component from the registry
     *
     * @param name
     */
    getComponent(name: string): CalsoftDrawerComponent
    {
        return this._componentRegistry.get(name);
    }
}
